<script>
export default {
    methods: {
        $can(permissionName) {
            return atob(Permissions).indexOf(permissionName) !== -1;
        },
        $hasRole(roleName) {
            return role === roleName;
        },
    },
};
</script>